var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
var ScrollNav = require('components/scroll-nav.js');
var PageHistory = require('lib/page-history.js');
var Device = require('lib/device.js');

function AboutNav(el) {
  this.$el = $(el);

  this.$nav = this.$el.find('.about-section-nav');
  this.$targets = $();

  $('.header .local-nav').empty().append(this.$nav);

  this.$nav.find('a').each(function(index, el) {
    var link = $(el).attr('href');
    var $t = $('[data-permalink="'+link+'"]');
    this.$targets = this.$targets.add($t);
  }.bind(this));

  $(window).on('vsc-page-ready', function() {
    this.scrollNav = new ScrollNav(this.$nav.find('ul'), this.$targets, {
      offset: ($('.header-bar').outerHeight() - 1) * -1
    });

    //Removes empty array elements
    var pathArray = window.location.pathname.split("/").filter( function(el) {
      return el
    });

    var id;
    if( pathArray.length > 1 && ( id = pathArray[1] ) ) {
      var scrollPos = $( '#' + id ).offset().top - this.$nav.outerHeight() - 20;
      if( scrollPos > 0 ) {
        $('html, body, main').animate({
          scrollTop: scrollPos
        }, 450);
        return false;
      }
    }

  }.bind(this));

  $(window).add('main').on('scroll', function(event) {
    var scrollTop = $(event.target).scrollTop();
    var sectionBottom = this.$el.offset().top + this.$el.outerHeight();

    if($(event.target).is('main')) {
      sectionBottom += scrollTop;
    }

    var showLocalNav = sectionBottom < scrollTop + 70;
    var localNavShowing = $('body').hasClass('local-nav-visible');

    if(localNavShowing && !showLocalNav) {
      $('body').removeClass('local-nav-visible');
      $(window).trigger('vsc-local-nav-hide');
    } else if(showLocalNav && !localNavShowing) {
      $('body').addClass('local-nav-visible');
      $( "body").removeClass( "js-search-bar-active" );
      $(window).trigger('vsc-local-nav-show');
    }
  }.bind(this))

  this.$el.on('click', 'a', function(event) {
    event.preventDefault();

    var link = $(event.currentTarget).attr('href');
    var $navLink = this.$nav.find('a[href="'+link+'"]').closest('li');

    $navLink.trigger('click');
  }.bind(this));

  
  this.$nav.find('select').on('focusin focus', function(event) {
    event.preventDefault();

    if(Device.isDefinitelyMobile && window.innerWidth < 600) {
      var scrollY = window.scrollY;

      $('html,body').animate({
        scrollTop: scrollY
      }, 300, function() {
        window.scrollTo(0, scrollY);
      });
    }
  });

  this.$nav.find('select').on('change', function(event) {
    var $select = $(event.currentTarget);
    var link = $select.val();

    this.$nav.find('a').filter('[href="'+link+'"]').closest('li').click();
  }.bind(this));

  this.$nav.on('scroll-nav-activate', 'li', function(event) {
    var $a = $(event.currentTarget).find('a');
    var link = $a.attr('href');
    var title = $a.attr('data-post-title');
    this.$nav.find('select').val(link);

    PageHistory.replaceState(null, title, link);
  }.bind(this));

  $(window).on('vsc-local-nav-show', function() {
    var $a = this.$nav.find('a').first();
    var link = $a.attr('href');
    var title = $a.attr('data-post-title');

    PageHistory.replaceState(null, title, link);
  }.bind(this));

  $(window).on('vsc-local-nav-hide', function() {
    var link = this.$nav.attr('data-post-permalink');
    var title = this.$nav.attr('data-post-title');

    PageHistory.replaceState(null, title, link);
  }.bind(this));
}

module.exports = AboutNav;
